import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'

import CustomDateFilter from '@/filters/custom-date'
import joinArrayFilter from '@/filters/join-array'
import printTypeFilter from '@/filters/print-type'

import SpinnerLoader from './components/SpinnerLoader.vue'

import './weblinks/_globals'
import './landingpages/_globals'
import './guestdocumentation/_globals'

import VueScrollTo from 'vue-scrollto'
import VueMeta from 'vue-meta'

Vue.use(CustomDateFilter)
Vue.use(joinArrayFilter)
Vue.use(printTypeFilter)

Vue.use(VueScrollTo, config.scrollToOptions)
Vue.use(VueMeta, { keyName: 'head' })

Vue.config.productionTip = false

const spinner = new Vue(SpinnerLoader).$mount()
Vue.prototype.$spinner = spinner
document.body.appendChild(spinner.$el)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
